import { render, staticRenderFns } from "./PersonalInfoSettings.vue?vue&type=template&id=c77868d0&"
import script from "./PersonalInfoSettings.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports